<div class="container-fluid">
  <div class="header-container">
    <div class="page-header"><span class="fa fa-file-text-o"></span>Claims list - {{status}}</div>

  </div>
  <div class="content">

    <!--MENU-->
    <p-tabMenu [model]="navigationItems" [activeItem]="selectedNavigationItem">
      <ng-template pTemplate="item" let-item let-i="index" style="padding:0px;">
        <div class="menu-container-filter" (click)="getClaims(item.ID)">
          <div class="menu-card-container-filter">
            <div class="menu-card-filter">
              <div class="menu-footer-filter">
                <div>{{item.title}}</div>
                <div class="footer-description-filter">{{item.description}}</div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </p-tabMenu>

    <!--TABLE-->
    <div class="row" style="padding-top: 20px;">
      <div class="col-md-12">
        <p-table #jobCardsTable [columns]="columns" [value]="claims">
          <!-- selectionMode="single" (onRowSelect)="onRowSelect($event)"> -->
          <ng-template pTemplate="caption">
            <div style="text-align: right">
              <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
              <input type="text" pInputText size="50" placeholder="{{ 'general.search' | translate }}"
                     (input)="jobCardsTable.filterGlobal($event.target['value'] , 'contains')"
                     style="width:auto"
                     name="globalSearch"/>
              <!--              todo: (dcorbett) - $event.target.value is not defined-->
            </div>
          </ng-template>

          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.type !== 'action' ? col.field : ''">
                {{ col.header }}
                <p-sortIcon [field]="col.field" style="vertical-align: middle;"
                            *ngIf="col.type !== 'action'"></p-sortIcon>
              </th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-claim let-columns="columns">
            <tr [pSelectableRow]="claim">
              <td *ngFor="let col of columns">
                <div *ngIf="col.type !== 'action' && col.type === 'string'">
                  {{
                  col.type === "date"
                    ? (claim[col.field] | date: "dd MMM yyyy")
                    : claim[col.field]
                  }}
                </div>
                <div *ngIf="col.type !== 'action' && col.type === 'days' && getOverdueOrNot(claim[col.field]) === true"
                     style="color:red">
                  {{
                  col.type === "date"
                    ? (claim[col.field] | date: "dd MMM yyyy")
                    : claim[col.field]
                  }}
                </div>
                <div
                  *ngIf="col.type !== 'action' && col.type === 'days' && getOverdueOrNot(claim[col.field]) === false">
                  {{
                  col.type === "date"
                    ? (claim[col.field] | date: "dd MMM yyyy")
                    : claim[col.field]
                  }}
                </div>
                <div *ngIf="col.type === 'action'"
                     style="display: grid;">
                  <button pButton type="button" class="p-button-raised icon" label="Open"
                          (click)="displayClaim(claim[col.field])" icon="pi pi-spin pi-spinner"
                          iconPos="right"></button>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>

      </div>
    </div>

  </div>
</div>

<p-sidebar #NavSideBar [(visible)]="showClaim" (onHide)="RefreshClaims(); NavSideBar.destroyModal()" [fullScreen]="true"
           [baseZIndex]="10000"
           [showCloseIcon]="true" [style]="{'overflow': 'scroll'}">
  <app-single-claim [claimID]="claimID"></app-single-claim>
</p-sidebar>
